export const checkAccess = (
    rights: string | undefined,
    access: string,
) => Boolean(rights && rights.includes(access));
